import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "autoComplete", "autoFocus", "disabled", "codeLength", "name", "onBlur", "onFocus", "onKeyDown", "onChange", "onKeyUp", "required", "value", "invert", "error"];
import React, { forwardRef } from 'react';
import { ControlWrapper } from "../ControlWrapper";
import { CodeInputField } from "./CodeInputField";
export var CodeInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var ariaLabel = props.ariaLabel,
    autoComplete = props.autoComplete,
    autoFocus = props.autoFocus,
    disabled = props.disabled,
    codeLength = props.codeLength,
    name = props.name,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onChange = props.onChange,
    onKeyUp = props.onKeyUp,
    required = props.required,
    value = props.value,
    invert = props.invert,
    error = props.error,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ControlWrapper, _extends({
    captionSize: "big",
    disabled: disabled,
    invert: invert,
    ref: ref,
    width: "default"
  }, otherProps, {
    "data-t-id": "components-CodeInput"
  }), /*#__PURE__*/React.createElement(CodeInputField, {
    ariaLabel: ariaLabel,
    codeLength: codeLength,
    disabled: disabled,
    invert: invert,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    status: error ? 'error' : 'default',
    value: value,
    "data-t-id": "components-CodeInput"
  }));
});